import libs from "../../libs"

const state = {
  reports: {
    data: {},
    offset: 0,
    limit: 10,
    total: 0
  },
  report: {
    nomor: null,
    tanggal: null,
    objek: null,
    status: null,
    analis: null,
    verifikator: null,
    mengetahui: null,
    analisa: null
  }
}

const getters = {
  reports: (state) => state.reports,
  report: (state) => state.report
}

const actions = {
  toLoadReports: async function ({ commit }, query) {
    commit('setLoading', 'memuat daftar laporan')

    const newQuery = libs.generateQuery(query, {
      offset: state.reports.offset,
      limit: state.reports.limit
    })

    const listReport = await this.dispatch('authenticatedApi', {
      method: 'get',
      url: `${window.config.BASEURL_API1}/reports?${newQuery.toString}`
    })

    if (listReport) {
      commit('setReports', {
        offset: newQuery.query.offset,
        limit: newQuery.query.limit,
        data: listReport.data.reports,
        total: listReport.data.total
      })
    }

    commit('unsetLoading')
  }
}

const mutations = {
  setReports: (state, reports) => state.reports = reports,
  resetReport: (state) => {
    state.report = {
      nomor: null,
      tanggal: null,
      objek: null,
      status: null,
      analis: null,
      verifikator: null,
      mengetahui: null,
      analisa: null
    }
  },
  setReport: (state, report) => state.report = { ...state.report, ...report }
}

export default {
  state,
  getters,
  actions,
  mutations
}
